export class DomainHelper
{
    static getDomain(): string
    {
        const host = window.location.hostname;
        if (host === "localhost")
        {
            return localStorage["domain"];
        }
        return host.split(".")[0];
    }
}
